import Vue from 'vue'
import Vuex from 'vuex'
import cardData from '@/data/cardData'
import colorData from '@/data/colorData'
import ColorUtil from '@/utils/ColorUtil'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    title: "Color Personality",
    question: "마음에 드는 것을 고르세요",
    currentQuestionNumber: -1,
    chosenCards: [],
    yourColorHSV: {"h": 0, "s": 0, "v": 0},
    yourColorName: "White",
    cardDataList: cardData.cardDataList,
    cardDataByQuestionNumber: cardData.cardDataByQuestionNumber,
    cardDataMaxPoints: cardData.cardDataMaxPoints,
    colorDataList: colorData.colorDataList,
    colorDatasByName: colorData.colorDatasByName,
    findNearestColorList: [],
    skip: false,
    colorTurningSystem: 0, //색상 추출 결과가 될 Hue 각도값.
    colorWeight: { "R": 0, "Y": 0, "G": 0, "C": 0, "B": 0, "M": 0 } // 선택한 카드에 대한 색상 가중치 값. 각도(Turning System)이 회전할 때 영향을 준다.
  },
  mutations: {
    setQuestionNumber: (state, payload) => {
      state.currentQuestionNumber = payload;
    },
    //특정 색상 방향으로 최대 length 만큼 이동한다
    turnToColor: (state, {color, length}) => {
      const colorCircle = ["R", "Y", "G", "C", "B", "M"];
                          // 0,  60, 120, 180, 240, 300
      const findColorIndex = colorCircle.findIndex(c=>c === color);
      const findColorRotate = findColorIndex * 60;
      
      //가중치만큼 다른 색상으로 이동하지 못한다.
      length -= (state.colorWeight[color]) * 0.5;
      length = Math.max(0, length);

      if (state.colorTurningSystem < findColorRotate) {
        const dist = findColorRotate - state.colorTurningSystem;

        if (dist < length)
          state.colorWeight[color] += length - dist;

        if (dist < 180) {
          state.colorTurningSystem += Math.min(length, dist);
        } else {
          state.colorTurningSystem -= Math.min(length, (360 - dist));

          if (state.colorTurningSystem < 0)
            state.colorTurningSystem += 360;

          state.colorTurningSystem %= 360;
        }
      }
      else
      {
        const dist = state.colorTurningSystem - findColorRotate;

        if (dist < length)
          state.colorWeight[color] += length - dist;

        if (dist < 180) {
          state.colorTurningSystem -= Math.min(length, dist);
        } else {
          state.colorTurningSystem += Math.min(length, (360 - dist));
          state.colorTurningSystem %= 360;
        }
      }

      // console.log(`to:${color}, colorTurningSystem: ${state.colorTurningSystem}, weight: ${state.colorWeight[color]}`);
    },
    setYourColorName: (state, colorName) => {
      state.yourColorName = colorName;
    },
    skipTitleAnimation: (state) => {
      state.skip = true;
    }
  },
  actions: {
    nextCards: ({ commit, state }, selectedCard) => {
      state.currentQuestionNumber += 1;
      state.chosenCards.push(selectedCard);

      const sumHsvColors = { "R": 0, "Y": 0, "G": 0, "C": 0, "B": 0, "M": 0, "S": 0, "V": 0, "K": 0 };
      Object.keys(sumHsvColors).forEach(key=>{
        state.chosenCards.forEach((chosenNumber, i)=>{
          const cardData = state.cardDataByQuestionNumber.get(i+1)[chosenNumber];
          sumHsvColors[key] += cardData[key];
        });
      });

      state.colorWeight = { "R": 0, "Y": 0, "G": 0, "C": 0, "B": 0, "M": 0 };
      state.colorTurningSystem = 0;
      state.chosenCards.forEach((chosenNumber, i)=>{
        const cardData = state.cardDataByQuestionNumber.get(i+1)[chosenNumber];
        let maxColor = { "color": "R", "length": 0 };
        ["R", "Y", "G", "C", "B", "M", "S"].forEach(c=>{
          if (maxColor.length < cardData[c]) {
            maxColor.color = c;
            maxColor.length = cardData[c];
          }
        });
        commit('turnToColor', maxColor);
      });

      let weight = 0;
      Object.keys(state.colorWeight).forEach(key=>{
        weight += state.colorWeight[key];
      });
      let resultHue = state.colorTurningSystem/360;
      let resultSaturation = sumHsvColors["K"]/60 + Math.max(0, Math.min(1.0, weight * 0.05));
      let resultValue =  Math.min(1.0, sumHsvColors["V"]/70);

      state.yourColorHSV = {
        "h": resultHue,
        "s": resultSaturation,
        "v": resultValue
      };

      state.yourColorName = ColorUtil.findNearestColorName(
        state.colorDataList, 
        state.yourColorHSV.h,
        state.yourColorHSV.s,
        state.yourColorHSV.v);
    },
    randomTest: ({ commit, state }) => {
      const randomCount = 150;
      const TestResult = {}
      for(let i = 0; i <randomCount; i++)
      {
        const testCase = Array.from({length: 12}, (undefined, i) => Math.floor(Math.random() * 4) + 1); 

        state.colorWeight = { "R": 0, "Y": 0, "G": 0, "C": 0, "B": 0, "M": 0 };
        state.colorTurningSystem = 0;
        testCase.forEach((chosenNumber, i)=>{
          const cardData = state.cardDataByQuestionNumber.get(i+1)[chosenNumber-1];
          let maxColor = { "color": "R", "length": 0 };
        
          ["R", "Y", "G", "C", "B", "M", "S"].forEach(c=>{
            if (maxColor.length < cardData[c]) {
              maxColor.color = c;
              maxColor.length = cardData[c];
            }
          });
          commit('turnToColor', maxColor);
        });

        const sumHsvColors = { "R": 0, "Y": 0, "G": 0, "C": 0, "B": 0, "M": 0, "S": 0, "V": 0, "K": 0 };
        Object.keys(sumHsvColors).forEach(key=>{
          testCase.forEach((chosenNumber, i)=>{
            const cardData = state.cardDataByQuestionNumber.get(i+1)[chosenNumber-1];
            sumHsvColors[key] += cardData[key];
          });
        });

        let weight = 0;
        Object.keys(state.colorWeight).forEach(key=>{
          weight += state.colorWeight[key];
        });
        let resultHue = state.colorTurningSystem/360;
        let resultSaturation = sumHsvColors["K"]/60 + Math.max(0, Math.min(1.0, weight * 0.05));
        let resultValue = 0.1 + Math.min(1.0, sumHsvColors["V"]/70);

        const yourColorHSV = {
          "h": resultHue.toFixed(4),
          "s": resultSaturation.toFixed(4),
          "v": resultValue
        };

        const yourColorName = ColorUtil.findNearestColorName(
          state.colorDataList, 
          yourColorHSV.h,
          yourColorHSV.s,
          yourColorHSV.v);

        if (!TestResult.hasOwnProperty(yourColorName)) {
          TestResult[yourColorName] = 1;
        } 
        TestResult[yourColorName] += 1;

        // console.log(`Test[${i}] : ${resultHue.toFixed(2)} ${yourColorName}`);
      }
      // console.log(`${JSON.stringify(TestResult)}`);
    }
  },
  getters: {
    questionCount: state => {
      return state.cardDataList.size;
    },
    percentAnswer: state => {
      return Math.floor((state.currentQuestionNumber)/(state.cardDataByQuestionNumber.size-1) * 100);
    },
    currentCards: state => {
      return state.cardDataByQuestionNumber.get(state.currentQuestionNumber+1);
    },
    previewCards: state => {
      return state.cardDataByQuestionNumber.get(state.currentQuestionNumber+2);
    }
  },
  modules: {
  }
})
